<app-header></app-header>
<app-spinner-container [detectRouteTransitions]="true"></app-spinner-container>
<router-outlet></router-outlet>
<app-footer></app-footer>
